import script from "./minimal-footer.vue?vue&type=script&lang=js"
export * from "./minimal-footer.vue?vue&type=script&lang=js"

import "./minimal-footer.vue?vue&type=style&index=0&id=ca834a1e&lang=scss"

const __exports__ = script;

export default __exports__